import {languageProcessing} from '@axyseo/index.js';
const {AbstractResearcher} = languageProcessing;

// All config
import firstWordExceptions from './config/firstWordExceptions';
import {all as functionWords} from './config/functionWords';
import transitionWords from './config/transitionWords';
import twoPartTransitionWords from './config/twoPartTransitionWords';
import keyphraseLength from './config/keyphraseLength';

// All helpers
import getStemmer from './helpers/getStemmer';
import isPassiveSentence from './helpers/isPassiveSentence';

/**
 * The researcher contains all the researches, helpers, data, and config.
 */
export default class Researcher extends AbstractResearcher {
  /**
   * Constructor
   * @param {Paper} paper The Paper object that is needed within the researches.
   * @constructor
   */
  constructor(paper) {
    super(paper);

    // Delete the researches that are not available in Swedish.
    delete this.defaultResearches.getFleschReadingScore;

    Object.assign(this.config, {
      language: 'sv',
      passiveConstructionType: 'morphological',
      firstWordExceptions,
      functionWords,
      transitionWords,
      twoPartTransitionWords,
      keyphraseLength
    });

    Object.assign(this.helpers, {
      getStemmer,
      isPassiveSentence
    });
  }
}
